(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.home = {
    attach: function (context, settings) {
      once('home', '.advices', context).forEach(function (block) {
        // TWeaks fancyBox
        $('[data-fancybox]').fancybox({
          lang: "en",
          i18n: {
            en: {
              CLOSE: Drupal.t("Close"),
              NEXT: Drupal.t("Next"),
              PREV: Drupal.t("Previous"),
              ERROR: Drupal.t("The requested content cannot be loaded. <br/> Please try again later."),
              PLAY_START: Drupal.t("Start slideshow"),
              PLAY_STOP: Drupal.t("Pause slideshow"),
              FULL_SCREEN: Drupal.t("Full screen"),
              THUMBS: Drupal.t("Thumbnails"),
              DOWNLOAD: Drupal.t("Download"),
              SHARE: Drupal.t("Share"),
              ZOOM: Drupal.t("Zoom"),
            },
          }
        });


        // Main banner

        const advices = new Swiper('.advices .swiper-container', {
          // Default parameters
          slidesPerView: 4,
          spaceBetween: 25,
          autoHeight: true,
          navigation: {
            nextEl: '.advices .swiper-control-next',
            prevEl: '.advices .swiper-control-prev',
          },
          a11y: {
            prevSlideMessage: Drupal.t('Go to previous advice'),
            nextSlideMessage: Drupal.t('Go to next advice'),
            firstSlideMessage: Drupal.t('Go to the first advice'),
            lastSlideMessage: Drupal.t('Go to the last advice'),
            paginationBulletMessage: Drupal.t('Go to the advice {{index}}'),
          },
          breakpoints: {
            769: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 2,
            },
            1216: {
              slidesPerView: 3,
            },
          }
        })

        // Video

        const player = new Plyr('#player');

      })
    }
  }
})(jQuery, Drupal, once, drupalSettings);
